exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.slip-enter-active[data-v-1e05a942],\r\n.slip-leave-active[data-v-1e05a942] {\r\n    transition: transform .25s\n}\n.slip-enter[data-v-1e05a942],\r\n.slip-leave-to[data-v-1e05a942] {\r\n    transform: translateX(100%);\n}\n.selector-pick-container[data-v-1e05a942] {\r\n    position: fixed;\r\n    width: 100vw;\r\n    height: 100%;\r\n    left: 0;\r\n    top: 0;\r\n    overflow: auto;\r\n    background-color: #f9f9f9;\r\n    z-index: 999;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-1e05a942&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/emapm-form/baseComponents/bsTransitionPage.vue
// module id = 164
// module chunks = 0